/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Tile layer for Leaflet that use the
 * [Maps API - Raster](https://developer.tomtom.com/maps-api/maps-api-documentation/raster)
 * from TomTom.
 *
 * @example
 * ```js
 * var tomtomLayer = new L.TomTomLayer({key: "<Your API key>"});
 * ```
 *
 * @class TomTomLayer
 * @module Map
 * @namespace L
 * @extends L.TileLayer
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     [TomTom's developer portal](https://developer.tomtom.com).
 *     When the key is passed on the map's initialization, it is set globally for all the services. It can be
 *     overwritten with the `tomtom.key()` method globally or per service with `tomtom.<service_name>.key()`
 *     functions. It is also possible to pass a specific key while working with instances of the services.
 * @param {"main"|"night"} [options.style="main"] The base map style to use
 * @param {"basic"|"hybrid"|"labels"} [options.layer="basic"] The base map's layer to use
 * @param {String} [options.language] Language to be used for map labels. Should be one of supported
 *      IETF language tags described
 *      [here](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#listOfSupportedLanguages).
 *      When data in specified language is not available for a specific label,
 *      [default language](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#defaultLanguageAlgorithm)
 *      is used.
 */
/* eslint-enable max-len */
/* jshint nomen:false */
define(['leaflet', 'security', 'http', 'endpoints', 'display/layers/mapTheme', './animator',
    './optionsComplementor', '../utils', 'requester/analytics', './tileSetTransform'],
function(L, security, http, endpoints, mapTheme, animator, optionsComplementor, Utils, analytics, tileSetTransform) {
    'use strict';

    function tileSizeEstimator(options) {
        return options.detectRetina && L.Browser.retina ? 512 : 256;
    }

    L.TomTomLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 20,
            subdomains: 'abcd',
            reuseTiles: true,
            detectRetina: true
        },
        /**
         * Name of raster layer. It can be used to differentiate layers.
         * @property name
         * @default "raster"
         * @type String
         */
        name: 'raster',
        initialize: function(options) {
            var key, theme, urlParams;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey(options.key);
            key = security.getKey('services/display');
            options.accessToken = key;
            urlParams = (key ? 'key={accessToken}' : '') +
                (options.geopolView ? '&view={geopolView}' : '') +
                (options.language ? '&language={language}' : '') +
                '&tileSize=' + tileSizeEstimator(options);
            this._url = http.protocol() + '://' + endpoints.tileLayer + (urlParams ? '?' + urlParams : '');
            theme = mapTheme.getTheme([options]);
            options.style = theme.style;
            options.layer = theme.layer;
            optionsComplementor.fillInSubdomainsOptions(options);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function(map) {
            this._map = map;
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', animator.loadAnimationFactory(this));
            }
            this._updateOpacity();
            this.bringToBack();
            Utils.updateMaxZoom(map, this.name);
        },
        updateOptions: function(options) {
            var theme = mapTheme.getTheme([this.options, options]);
            this.options.style = theme.style;
            this.options.layer = theme.layer;
            this.redraw();
        },
        createTile: function(coords, done) {
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomLayer = function(options) {
        return new L.TomTomLayer(options);
    };

    return L.tomTomLayer;
});



// WEBPACK FOOTER //
// ./display/layers/tileLayer.js